import React,{useEffect,useState} from "react";
import {all_routes} from '../../router/all_routes'
import {Link} from 'react-router-dom'
import ImageWithBasePath from '../../../core/img'
import Table from "../../../core/dataTable/non-pager/index";
/* -- biz9 import start -- */
//import AlertMessage from '../alertMessage';
import {UrlQuery} from "biz9-react-utility";
import {Image_Format,Image_Type} from "biz9-image";
import {User_Logic} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {Portal_Table,Portal_Url} from "biz9-portal-app";
import {Type,Url,Field,Title} from "../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../project";
import {Log,Num,Str,DateTime} from "biz9-utility";
/* -- biz9 import start -- */
const Product_App_Payment_Success = () => {
    const query = UrlQuery();
	const [val_order_number,setValOrderNumber] = useState(query.get('order_number'));
    const [product, setProduct] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{product_type:"",delivery_time:"",sale_count:"",view_count:""}}));
   	const [user,setUser] = useState(User.get());
    const [order,setOrder] = useState(Data_Logic.get(Portal_Table.ORDER,0,{data:{order_item_list:[]}}));
    const [order_payment_list,setOrderPaymentList] = useState([]);
    useEffect(() => {
	 if(val_order_number){
            get_data();
        }
    },[val_order_number]);
    async function get_data() {
        /*
        let [response,data] = await App_Data_Service.post(App.get_url(Portal_Url.DATA_POST)Portal_Url.ORDER,{order_number:val_order_number,option:{get_payment:true,payment_list_sort_order:{date_create:-1}}});
        setOrder(data);
        if(data.order_item_list.length>0){
            setProduct(data.order_item_list[0].parent_item);
        }
        setOrderPaymentList(data.order_payment_list);
        */
    };
 const order_payment_list_columns = [
    {
title: "Payment Amount",
           dataIndex: "payment_amount",
           key: "payment_amount",
           render: (text: string, record: any) => (
                   <>
                   {Str.get_money(record.payment_amount)}
                   </>
                   )
    },
    {
title: "Payment Method Type",
       dataIndex: "payment_method_type",
       key: "payment_method_type",
       render: (text: string, record: any) => (
               <>
               {record.payment_method_type}
               </>
               )
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        )
    },
    {
title: "Transaction ID",
       dataIndex: "transaction_id",
       key: "transaction_id",
       render: (text: string, record: any) => (
               <>
               {record.transaction_id}
               </>
               )
    },
    ];

    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar breadcrumb-bar-info">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item">
            <Link to={all_routes.home}>Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Thank You
            </li>
            </ol>
            </nav>
            <h2 className="breadcrumb-title mb-0">
            Thank You <span className="text-primary" />
            </h2>
            </div>
            </div>
            </div>
            </div>
            {/* /Breadcrumb */}
    {/* Page Content */}
    <div className="page-content">
        <div className="container">
        {/* Received gigs */}
    <div className="service-wrap text-center rounded-0 border-0 shadow-none p-0">
        <div className="received-iocn mb-4 m-auto d-flex align-items-center justify-content-center">
        <i className="ti ti-check" />
        </div>
        <h5 className="mb-1"> Thank you! Your Payment has been Recieved </h5>
        <p>
        {" "}
    Order Number : <span> #{order.order_number} </span>{" "}
    </p>
        </div>
        {/* Received gigs */}
    {/* Order details */}
    <div className="service-widget member-widget">
        <h5 className="service-head d-flex align-items-center">
        Order Details
        </h5>
        <div className="user-details bg-light p-3 mb-16">
        <div  style={{display: !product.image_filename ? 'none' : 'block'}} className="user-img service-user">
        <ImageWithBasePath   src={Image.get_url(product.image_filename,Image_Format.THUMB)}  alt="img" />
        </div>
        <div className="user-info">
        <h5>
        <span className="me-2">
        {product.title}
    </span>{" "}
    </h5>
        <p>{product.delivery_time}</p>
        </div>
        </div>
        <ul className="member-info">
        {order.order_item_list.map((item) => (
                    <>
                    <li>{item.parent_item.title}
                    <span>{Str.get_money(item.cost)}</span>
                    </li>
                    {item.order_sub_item_list.map((sub_item) => (
                                <li>
                                {sub_item.parent_item.title}
                                <span>{Str.get_money(sub_item.cost)}</span>
                                </li>
                                ))}
                    </>

                    ))}
    </ul>
        <div className="about-me m-0 pt-3 mt-3 border-top border-grey">
        <h6 className="d-flex justify-content-between align-items-center m-0">
        Total <span> {Str.get_money(order.grand_total)}</span>
        </h6>
        <h6 className="d-flex justify-content-between align-items-center m-0 mt-3">
        Payment Plan <span> {order.payment_plan}</span>
        </h6>


        </div>
        </div>
        {/* Order details */}
    {/* Billing details */}
    <div className="row">
        <div className="col-lg-12">
        <div className="service-widget">
        <h5 className="service-head mb-3">Billing Information </h5>
        <h6 className="mb-2">{user.title}</h6>
        <div className="service-text">
        <p className="mb-1">
        {User_Logic.get_country_state_city(user)}
    </p>
        <p className="mb-0">Email ID : {user.email}</p>
        </div>
        </div>
        </div>
        <div className="col-lg-12">
        <div className="service-widget m-0">
        <h5 className="service-head mb-3">Payment Details </h5>

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="table-responsive custom-table col-lg-12" >
                <Table allow_multiple={true} table={Portal_Table.ORDER} dataSource={order_payment_list} columns={order_payment_list_columns} Selection={false} />
                </div>
        </div>
        </div>
        </div>
        </div>
        {/* Billing details */}
    </div>
        </div>
        {/* Page Content */}
    </>
        )
}

export default Product_App_Payment_Success
